import { apiClient } from "@/modules/shared/utils/apiClient";

import { AVAILABILITY_TIMEOUT_MS } from "../consts/availabilityTimeout";
import { CoachAvailabilityRequest } from "../types/CoachAvailabilityRequest";
import { CoachAvailabilityResponse } from "../types/CoachAvailabilityResponse";

export const getCoachAvailability = (data: CoachAvailabilityRequest) => {
  const { coachId, ...params } = data;
  const queryParams = new URLSearchParams(params).toString();

  return apiClient.get<CoachAvailabilityResponse>(
    `/coach/${coachId}/availability?${queryParams}`,
    { timeoutMs: AVAILABILITY_TIMEOUT_MS },
  );
};
